import React, {useEffect, useState} from 'react';
import Switch from "../Switch/Switch";
import "react-datepicker/dist/react-datepicker.css";
import RangeDate from "../RangeDate/RangeDate";
import SingleDate from "../SingleDate/SingleDate";
import Button from "../Button/Button";
import {parseDateInSeconds} from "../../hooks/parseDateInSeconds";
import {useDispatch, useSelector} from "react-redux";
import {change_loading, set_range_date} from "../../store/reducers/main_reducer";
import {ThunkGetDataUsers} from "../../store/Thunks/ThunkGetDataUsers";

const ChooseDate = () => {

    const dispatch = useDispatch()

    const {user_id, admin} = useSelector(state => state.main)

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(null);
    const [error, setError] = useState('')
    const [chooseDate, setChooseDate] = useState(false)

    const onChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };

    const setDateSingleDate = (date) => {
        setStartDate(date)
        setEndDate(date)
    }

    const get_data_users = () => {

        dispatch(change_loading(true))
        const id_user = (!admin) ? `user_${user_id}` : ''
        console.log(id_user)

        setError('')

        const dateStart = (startDate !== null) ? startDate.toLocaleDateString() : null
        const dateEnd = (endDate !== null) ? endDate.toLocaleDateString() : null

        if(dateStart === null || dateEnd === null) {
            setError('Выбеирте диапозон дат')
            return
        }

        let seconds_date_start = parseDateInSeconds(dateStart)
        const seconds_date_end = parseDateInSeconds(dateEnd)

        const array_dates = []

        while(seconds_date_start <= seconds_date_end) {
            const date = new Date(seconds_date_start * 1000).toLocaleDateString()

            array_dates.push(date)

            seconds_date_start = seconds_date_start + 86400
        }

        dispatch(set_range_date(array_dates))

        dispatch(ThunkGetDataUsers(dateStart, dateEnd, id_user))

        dispatch(change_loading(false))
    }

    return (
        <div>
            <div className={'mt-10'}>
                <Switch checked={chooseDate} setChecked={setChooseDate} />
            </div>

            <div>
                {!chooseDate ?
                    <RangeDate startDate={startDate} endDate={endDate} onChange={onChange} /> :
                    <SingleDate startDate={startDate}  setStartDate={setDateSingleDate} />
                }
            </div>

            {error && <div className={'text-red-400 text-center text-2xl mt-4'}>{error}</div>}
            <Button get_data={get_data_users}>Получить данные</Button>
        </div>
    );
};

export default ChooseDate;